export default __webpack_public_path__ + "static/media/Resume-01.450e2d6c.png";